/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GeoTestTypeCellDTO { 
    cellType?: string;
    value: string;
    formattedValue: string;
    disabled?: boolean;
    testType?: GeoTestTypeCellDTO.TestTypeEnum;
    iconName?: string;
}
export namespace GeoTestTypeCellDTO {
    export type TestTypeEnum = 'Scale' | 'Holdout' | 'Contribution';
    export const TestTypeEnum = {
        Scale: 'Scale' as TestTypeEnum,
        Holdout: 'Holdout' as TestTypeEnum,
        Contribution: 'Contribution' as TestTypeEnum
    };
}


